module.exports = __webpack_public_path__ + "static/img/qcode.58ac5b10.png";